export default __webpack_public_path__ + "assets/fonts/BerninaSans-NarrowRegular.8f0260d0c51b2537d119e38e9e317493.otf";